
import { FC, useContext, useMemo } from 'external/react'
import {styled} from 'external/material'

import { TextAreaField } from 'components/common/TextAreaField'
import { TeacherContext } from 'teacher/context'

type DailyIntentProps = {
    id: number
}
const StyledDailyIntent = styled('div')(dailyIntentStyles as any)

const DailyIntent: FC<DailyIntentProps> = props => {

    const {id} = props
    const {translate, updateState, newPlan} = useContext(TeacherContext) as any
    const dailyPlan = useMemo(() => {
      const dailyPlans = newPlan.content.dailyPlanning
      const dailyPlan:any = id >= 0 && id < dailyPlans.length ? dailyPlans[id] : {intent: ''}
      return dailyPlan
    }, [ newPlan.content.dailyPlanning, id])


  function updateDailyIntent (intent:string) {
    updateState({newPlan: {content: {dailyPlanning: {[id]: {intent: {$set: intent}}}}}})
  }

    return (
        <StyledDailyIntent>
        <div className='label'>{translate('planning-rd-daily-intent')}</div>
        <div className='input'>
            <TextAreaField label={''} value={dailyPlan.intent} textAreaStyles={{height: '60px'}} onChange={updateDailyIntent} />
        </div>
       </StyledDailyIntent>
    )
}

export {DailyIntent as default}

function dailyIntentStyles() {
  return {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    '& > .label': {
      
    },
    '& > .input': {
      
    }
    
  }
}